


















































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";

import dayjs from "dayjs";
const service = namespace("service");
const base = namespace("base");
const staff = namespace("staff");
const testingItem = namespace("testing-item");

@Component({})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @service.Mutation setCurrentTabType;
  @testingItem.Action getTestOrdeList;
  @testingItem.Action getTestingTemplateList;
  @service.Action onlineVerificationCode;
  @service.Action completeOrder;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  orderList: any[] = [];
  showPickingTips: boolean = false;
  searchForm = {
    orderTimeEnd: "",
    orderTimeStart: "",
    orderStatus: "",
    technicianCode: "",
    searchKey: "",
    templateCode: ""
  };
  orderStatus: any = "";
  testTemplateList: any[] = [];
  orderSourceList: any[] = [];

  created() {
    this.loadListData();
    this.init();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("check_order_status").then(data => {
      this.orderStatus = data;
    });
    // 模板列表
    this.getTestingTemplateList({
      pageNum: this.mix_pageNum,
      pageSize: 999
    }).then(data => {
      this.testTemplateList = data.data.list.map(item => ({
        label: item.checkTemplateName,
        value: item.checkTemplateCode
      }));
    });
    // 员工和顾问 List
    this.getStaffList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      const staffList =
        data.data.list &&
        data.data.list.map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
      this.staffList = staffList;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getTestOrdeList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus(tab) {
    this.setCurrentTabType(tab.type);
    this.mix_pageNum = 1;
    this.loadListData();
  }
  invoicingList: any[] = [];
  staffList: any[] = [];
  get searchList() {
    return [
      {
        label: window._I18N.t("test.keyword"),
        type: "input",
        value: "",
        prop: "searchKey",
        placeholder: window._I18N.t("test.license-name-mobile-vincode")
      },
      {
        label: window._I18N.t("finance.creation-time"),
        type: "daterange",
        value: "",
        prop: "createDate"
      },
      {
        label: window._I18N.t("test.detection-template"),
        type: "select",
        selectList: this.testTemplateList,
        value: "",
        prop: "templateCode"
      },
      {
        label: window._I18N.t("test.service-consultant"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "advisorCode"
      },
      {
        label: window._I18N.t("test.service-technician"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "technicianCode"
      },
      {
        label: window._I18N.t("finance.state"),
        type: "select",
        selectList: this.orderStatus,
        value: "",
        prop: "orderStatus"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "createDate") {
          if (item.value) {
            this.searchForm["orderTimeStart"] = item.value[0];
            this.searchForm["orderTimeEnd"] = item.value[1];
          } else {
            this.searchForm["orderTimeStart"] = "";
            this.searchForm["orderTimeEnd"] = "";
          }
        } else if (item.prop === "orderStatus") {
          this.searchForm[item.prop] = item.value ? item.value : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleLinkCommand(url) {
    this.$router.push(url);
  }
  showOrderVaildCode: boolean = false; // 提否显示核销弹窗

  handleEdit(row) {
    this.$router.push(`/test/edit/${row.checkOrderNo}`);
  }

  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/test/view/${row.checkOrderNo}`
    });
    window.open(href, "_blank");
  }
}
